import script from "./createTiersPayant.vue?vue&type=script&setup=true&lang=ts"
export * from "./createTiersPayant.vue?vue&type=script&setup=true&lang=ts"

import "./createTiersPayant.vue?vue&type=style&index=0&id=0d5e6db3&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5e6db3"]])

export default __exports__